const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const moment = require('moment');
const classNames = require('classnames');
// @constants
const { DATE_FORMAT_SHORT_TIME_24 } = require('constants/index');
const {
    CHAT_SENDER_TYPE: {
        CLIENT,
        MESSAGE_TYPE
    },
    CHAT_MESSAGE_STATUS: {
        ERROR,
        SENDING,
        SENT
    }
} = require('constants/chat');
// @utilities
const { FormattedText } = require('core/i18n').i18n;
require('./ChatMessage.scss');

class ChatMessage extends React.Component {

    buildErrorLabel(){
        return (
            <div>
                <i className="icon-error chat-message__status-icon chat-message__status-icon--error" />
                <FormattedText
                    className="chat-message__status-label chat-message__status-label--error"
                    value="chat-statusError"
                />
            </div>
        );
    }

    buildLogoIcon() {
        let logoIcon;
        const { immMessage, userAvatar, userFirstLetter } = this.props;
        const type = immMessage.getIn(['from', 'type']).toLowerCase();
        const letter = type === CLIENT.toLowerCase() ? userFirstLetter : '';
        if (type === CLIENT.toLowerCase() && userAvatar) {
            logoIcon = (<div className={classNames('chat-message__logo', `chat-message__logo--client-avatar`)}>
                <img className="chat-message__logo--client-avatar-img" src={userAvatar} />
            </div>);
        } else {
            logoIcon = (<div className={classNames('chat-message__logo', `chat-message__logo--${type}`)}>{letter}</div>);
        }
        return logoIcon;
    }

    buildSendingLabel(){
        return (
            <FormattedText
                className="chat-message__status-label"
                value="chat-statusSending"
            />
        );
    }

    buildTimeLabel(){
        const { immMessage } = this.props;
        const currentTime = moment(immMessage.get('utcTime')).format(DATE_FORMAT_SHORT_TIME_24);
        return (
            <span className="chat-message__status-label">
                {currentTime}
            </span>
        );
    }

    render() {
        const { immMessage } = this.props;
        const type = immMessage.getIn(['from', 'type']).toLowerCase();
        const messageType = immMessage.get('messageType') && immMessage.get('messageType').toLowerCase();
        let labelElement;
        switch (immMessage.get('status')){
            case ERROR:
                labelElement = this.buildErrorLabel();
                break;
            case SENDING:
            case SENT:
                labelElement = this.buildSendingLabel();
                break;
            default:
                labelElement = (messageType !== MESSAGE_TYPE) && this.buildTimeLabel();
            break;
        }
        return (
            <div className={classNames('chat-message', `chat-message--${type}`)}>
                {this.buildLogoIcon()}
                <pre className={classNames('chat-message__text', `chat-message__text--${messageType}`)}>{immMessage.get('text')}</pre>
                {labelElement}
            </div>
        );
    }
}

ChatMessage.propTypes = {
    immMessage: PropTypes.object.isRequired,
    userAvatar: PropTypes.object,
    userFirstLetter: PropTypes.string
};

module.exports = ChatMessage;
